import { useSession } from "next-auth/react";

const useIsAuth = () => {
  const { data: session, status } = useSession();
  return session !== null && status === "authenticated";
};

export default useIsAuth;
